import * as get from 'lodash/get';

import { OutputResult } from '../models/output-result.model';
import { OutputSelector } from './output-selector.interface';

export class SelectLast implements OutputSelector {
	public select(outputs: OutputResult[]): string {
		if (outputs instanceof Array && get(outputs, 'length')) {
			return outputs[outputs.length - 1].output;
		}
		throw new Error('Output is not in the right format');
	}
}
